<form [formGroup]="dateForm" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="45%" class="from-block">
    <mat-form-field class="datepicker" color="accent">
      <input
        matInput
        formControlName="startDate"
        [matDatepicker]="fromPicker"
        [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_FROM' | translate"
        (focus)="fromPicker.open()"
      />
      <mat-datepicker-toggle [disableRipple]="true" matSuffix [for]="fromPicker">
        <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
      <mat-hint *ngIf="startDate.value" (click)="resetStartDate()">{{ 'FILTER_ENGINE.CLEAR' | translate }}</mat-hint>
    </mat-form-field>

    <div [ngClass]="{ 'timepicker-visible': startDate.value }" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" class="timepicker-hidden">
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="startHours" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_HOURS' | translate">
          <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span>:</span>
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="startMinutes" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_MINUTES' | translate">
          <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="45%" class="to-block">
    <mat-form-field class="datepicker" color="accent">
      <input
        matInput
        formControlName="endDate"
        [matDatepicker]="toPicker"
        [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_TO' | translate"
        (focus)="toPicker.open()"
      />
      <mat-datepicker-toggle matSuffix [for]="toPicker">
        <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
      <mat-hint *ngIf="endDate.value" (click)="resetEndDate()">{{ 'FILTER_ENGINE.CLEAR' | translate }}</mat-hint>
    </mat-form-field>

    <div [ngClass]="{ 'timepicker-visible': endDate.value }" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" class="timepicker-hidden">
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="endHours" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_HOURS' | translate">
          <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span>:</span>
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="endMinutes" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_MINUTES' | translate">
          <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <button
    mat-mini-fab
    color="accent"
    fxFlex="10%"
    [disabled]="!startDate.value && !endDate.value"
    [ngClass]="{ 'add-button-on': startDate.value || endDate.value }"
    (click)="onValidation()"
  >
    <mat-icon>add</mat-icon>
  </button>
</form>
